import { Link } from "react-router-dom";
import { HeartPulse, ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-[#E2E8F0] bg-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-6 py-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#0284C7] text-white"><HeartPulse className="h-4 w-4" strokeWidth={2.6} /></div>
            <span className="text-base font-extrabold tracking-tight text-slate-900">SaludCitaRD</span>
          </Link>
          <Link to="/registro" className="flex items-center gap-1.5 text-sm font-bold text-[#0284C7]" data-testid="terms-back"><ArrowLeft className="h-4 w-4" /> Volver</Link>
        </div>
      </header>

      <div className="mx-auto max-w-3xl px-6 py-10">
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900">Términos, Condiciones y Política de Privacidad</h1>
        <p className="mt-2 text-sm font-semibold text-slate-400">Última actualización: borrador · contenido de ejemplo</p>

        <div className="mt-8 space-y-6 text-sm font-semibold leading-relaxed text-slate-600" data-testid="terms-content">
          <section>
            <h2 className="text-lg font-extrabold text-slate-900">1. Aceptación</h2>
            <p className="mt-2">Al registrarte y usar SaludCitaRD aceptas estos Términos y la presente Política de Privacidad. Si no estás de acuerdo, no utilices la plataforma. <em>(Texto de ejemplo, pendiente de revisión legal.)</em></p>
          </section>
          <section>
            <h2 className="text-lg font-extrabold text-slate-900">2. Tratamiento de datos personales</h2>
            <p className="mt-2">Recopilamos datos de identificación, contacto y de salud necesarios para gestionar citas, turnos y expedientes clínicos. Los datos se almacenan de forma segura y se usan únicamente para prestar el servicio, cumplir obligaciones legales y mejorar la atención.</p>
          </section>
          <section>
            <h2 className="text-lg font-extrabold text-slate-900">3. Uso de la información de salud</h2>
            <p className="mt-2">La información clínica registrada por los médicos (motivo, hallazgos, diagnóstico, plan de tratamiento, alergias y receta) es confidencial y solo es accesible para el médico tratante, su equipo autorizado y el propio paciente.</p>
          </section>
          <section>
            <h2 className="text-lg font-extrabold text-slate-900">4. Derechos del titular</h2>
            <p className="mt-2">Puedes solicitar acceso, rectificación o eliminación de tus datos personales conforme a la legislación vigente de la República Dominicana en materia de protección de datos.</p>
          </section>
          <section>
            <h2 className="text-lg font-extrabold text-slate-900">5. Contacto</h2>
            <p className="mt-2">Para ejercer tus derechos o realizar consultas sobre privacidad, contacta al administrador de SaludCitaRD. <em>(Sustituir por datos de contacto reales.)</em></p>
          </section>
        </div>
      </div>
    </div>
  );
}
